import { render } from "./InsightArticlePage.vue?vue&type=template&id=65d1f10c"
import script from "./InsightArticlePage.vue?vue&type=script&lang=js"
export * from "./InsightArticlePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__